//日期格式化
function formatDateToNumberObj(date = new Date()) {
    let [year, month, day, hour, minute, second] = [date.getFullYear(), date.getMonth() + 1, date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()];
    return {
        year, month, day, hour, minute, second
    }
}

//小于10的数字前面填充字符0
function formatNumber(n) {
    n = n.toString();
    return n[1] ? n : '0' + n;
}

//按照传入格式格式化时间
//格式自定义
function format(format = 'yyyy-mm-dd hh:mm:ss', date = new Date()) {
    date=new Date(date);
    let dateObj = formatDateToNumberObj(date);
    switch (format.toLowerCase()) {
        case 'yyyy-mm-dd hh:mm:ss':
            return [dateObj.year, dateObj.month, dateObj.day].map(formatNumber).join('-') + ' ' + [dateObj.hour, dateObj.minute, dateObj.second].map(formatNumber).join(':');
        case 'yyyy-mm-dd hh:mm':
            return [dateObj.year, dateObj.month, dateObj.day].map(formatNumber).join('-') + ' ' + [dateObj.hour, dateObj.minute].map(formatNumber).join(':');
        case 'yyyy-mm-dd':
            return [dateObj.year, dateObj.month, dateObj.day].map(formatNumber).join('-');
        case 'mm-dd':
            return [dateObj.month, dateObj.day].map(formatNumber).join('-');
        case 'hh:mm:ss':
            return [dateObj.hour, dateObj.minute, dateObj.second].map(formatNumber).join(':');
        case 'hh:mm':
            return [dateObj.hour, dateObj.minute].map(formatNumber).join(':');
    }
}

/**
 * 计算日期相差
 * @param {*} startDate 
 * @param {*} endDate 
 */
function getDateDistance(startDate, endDate) {
    var sdate = new Date(startDate);
    var now = new Date(endDate);
    var days = now.getTime() - sdate.getTime();
    var day = parseInt(days / (1000 * 60 * 60 * 24));
    return day;
}

export default {
    format,
    getDateDistance
}


// WEBPACK FOOTER //
// ./src/helper/dateformat.js